"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleDrawPropertySchema = void 0;
const zod_1 = require("zod");
const zod_partial_1 = require("../../Utils/zod-partial");
const Text_1 = require("./Text");
exports.ModuleDrawPropertySchema = (0, zod_partial_1.partialWithoutDefaults)(Text_1.TextSchema)
    .extend({
    value: zod_1.z.string(),
    layer: zod_1.z.number().optional(),
    hidden: zod_1.z.boolean().optional(),
})
    .strict();
//# sourceMappingURL=ModuleDrawProperty.js.map